<section class="section-1 logo-click-container navigation-primary-header">
	<object
		aria-label="Short Solutions Logo Home Page"
		class="logo"
		data="/assets/images/Logo/Logo.svg"
		type="image/svg+xml"
	>
		<img
			src="/assets/images/Logo/Logo.svg"
			alt="Short Solutions Logo"
			loading="lazy"
		/>
	</object>

	<a
		class="active"
		aria-current="page"
		aria-label="Short Solutions Home Page"
		[routerLink]="['/home']"
	>
		<span class="logo-click"></span>
	</a>
</section>

<nav class="section-2">
	<button
		class="mobile-nav-toggle"
		aria-controls="navigation-primary"
		aria-label="Site Navigation Menu"
		data-target="#navigation-primary"
		(click)="clickit()"
		[attr.aria-expanded]="toggleMe"
	>
		<span class="sr-only">Menu</span>
	</button>

	<ul
		id="navigation-primary"
		class="flex ff-sans-cond navigation-primary navigation-indicators uppercase letter-spacing-2"
		(click)="clickit()"
		[class.sidemenu-opened]="toggleMe"
		[attr.aria-expanded]="toggleMe"
	>
		@for (menu of navMenus; track menu.path) {
		<li
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: true }"
		>
			<a [routerLink]="['/', menu.path]">
				<span aria-hidden="true"><i [class]="menu.icon"></i></span>
				{{ menu.btnText }}
			</a>
		</li>
		} @empty {
		<li>No menu items.</li>
		}

		<li>
			<button
				class="theme-toggle"
				(click)="toggleTheme()"
				aria-label="Toggle theme"
				[attr.aria-pressed]="theme === 'dark'"
			>
				<span
					class="theme-icon"
					aria-hidden="true"
					style="
						display: inline-block;
						transition: transform 0.25s ease, opacity 0.25s ease;
					"
				>
					<!-- Sun (light) -->
					<svg
						class="icon icon-sun"
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						[style.opacity]="theme === 'dark' ? '0' : '1'"
					>
						<path
							d="M12 3v2M12 19v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
							stroke="currentColor"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<circle cx="12" cy="12" r="3" fill="currentColor" />
					</svg>

					<!-- Moon (dark) -->
					<svg
						class="icon icon-moon"
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						[style.opacity]="theme === 'dark' ? '1' : '0'"
					>
						<path
							d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
							fill="currentColor"
						/>
					</svg>
				</span>
			</button>
		</li>
	</ul>
</nav>
